module.exports = __webpack_public_path__ + "media/Components/Logos/icon-gallery-60d5e41a3c86b3cb645f74b9c222b506.svg";